module.exports = __webpack_public_path__ + "report.svg?09eceb09121ca1601d04b5e41f132008";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/report.svg
// module id = 319
// module chunks = 2